var Backbone, SupportProgressBarView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportProgressBarView = (function(superClass) {
  extend(SupportProgressBarView, superClass);

  function SupportProgressBarView() {
    return SupportProgressBarView.__super__.constructor.apply(this, arguments);
  }

  SupportProgressBarView.prototype.tagName = 'ol';

  SupportProgressBarView.prototype.className = 'steps';

  SupportProgressBarView.prototype.initialize = function() {
    return this.I18nScope = 'modules.support';
  };

  SupportProgressBarView.prototype.render = function() {
    var results, x;
    x = 1;
    if (Groupon.Support.MAXINDEX === void 0) {
      Groupon.Support.MAXINDEX = 0;
    }
    results = [];
    while (!(x > Groupon.Support.MAXINDEX)) {
      if (x <= Groupon.Support.CURRENTVIEW.id) {
        this.$el.append("<li class='active c-bg-prim'><a class = 'progressBar' href='javascript:;'>" + x + "</a></li>");
      } else {
        this.$el.append("<li><a class = 'progressBar' href='javascript:;'>" + x + "</a></li>");
      }
      results.push(++x);
    }
    return results;
  };

  return SupportProgressBarView;

})(Backbone.View);

module.exports = SupportProgressBarView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9wcm9ncmVzc19iYXJfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9rdW1hcnJhL25hcGlzdHJhbm8vYnVpbGQvMTUwNDc3ODE0MzUyNi03NjE3Ny9wcm9kdWN0aW9uLTIwMTcuMDkuMDdfMDkuNTQvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL3Byb2dyZXNzX2Jhcl92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxJQUFBLGdDQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUVQOzs7Ozs7O21DQUNKLE9BQUEsR0FBUzs7bUNBQ1QsU0FBQSxHQUFXOzttQ0FFWCxVQUFBLEdBQVksU0FBQTtXQUNWLElBQUMsQ0FBQSxTQUFELEdBQWE7RUFESDs7bUNBR1osTUFBQSxHQUFRLFNBQUE7QUFDTixRQUFBO0lBQUEsQ0FBQSxHQUFJO0lBQ0osSUFBRyxPQUFPLENBQUMsT0FBTyxDQUFDLFFBQWhCLEtBQTRCLE1BQS9CO01BQ0UsT0FBTyxDQUFDLE9BQU8sQ0FBQyxRQUFoQixHQUEyQixFQUQ3Qjs7QUFHQTtXQUFBLENBQUEsQ0FBTSxDQUFBLEdBQUksT0FBTyxDQUFDLE9BQU8sQ0FBQyxRQUExQixDQUFBO01BQ0UsSUFBRyxDQUFBLElBQUssT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsRUFBcEM7UUFDRSxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSw0RUFBQSxHQUE2RSxDQUE3RSxHQUErRSxXQUEzRixFQURGO09BQUEsTUFBQTtRQUdFLElBQUMsQ0FBQSxHQUFHLENBQUMsTUFBTCxDQUFZLG1EQUFBLEdBQW9ELENBQXBELEdBQXNELFdBQWxFLEVBSEY7O21CQUlBLEVBQUU7SUFMSixDQUFBOztFQUxNOzs7O0dBUDJCLFFBQVEsQ0FBQzs7QUFtQjlDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
